module.exports = __webpack_public_path__ + "img/save.89d80f98.svg";